// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"0b63dc5f","147":"4dada7a9","171":"2f7d40e5","228":"bf40990d","432":"2a48f46c","435":"a544e22e","453":"cf26855b","507":"7cd683ea","521":"a358e528","528":"3f56084d","594":"09a39d01","743":"31b8e6b3","780":"947e3305"}[chunkId] + ".chunk.js";
};